import React, { useState } from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const styles = {
  delete: {
    position: 'absolute',
    right: -3,
    top: -3,
  },
}

function ActionMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null);

  const actionMnuShow = (ev) => {
    ev.stopPropagation();
    setAnchorEl(ev.currentTarget);
  }

  const actionMnuClose = (ev) => {
    ev.stopPropagation();
    setAnchorEl(null);
  }

  const deleteNote = (ev) => {
    actionMnuClose(ev);
    if (window.confirm(`Czy na pewno usunąc notatkę: "${props.note.title}"?`)) {
      props.deleteNote(props.note.id);
    }
  }

  const openNote = ev => {
    actionMnuClose(ev);
    props.showNote(props.note);
  }

  return (
    <>
      <IconButton
        aria-label="More"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={actionMnuShow}
        style={styles.delete}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={actionMnuClose}
      >
        <MenuItem onClick={openNote}>Otwórz</MenuItem>
        <MenuItem onClick={deleteNote}>Usuń</MenuItem>
      </Menu>
    </>
  );

}

export default ActionMenu;